import { useEffect, useState } from "react";
import React from "react";
import { fetchBalanceEntries, fetchBalance } from "../services/dataService";
import { deleteEntry } from "../services/deleteEntry";
import TransactionItem from "../components/reusable/TransactionItem";
import LoadingScreen from "./reusable/loadingScreen";

function BalanceSheet({ startDate, endDate, userId, admin, AssociateUser,role }) {
  const [loading, setLoading] = useState(false);
  const [grandTotal, setGrandTotal] = useState(0);
  const [Total, setTotal] = useState(0);
  const [previousBalance, setPreviousBalance] = useState(0);
  const [balanceData, setBalanceData] = useState({
    morning: {},
    evening: {},
    borrow: [],
  });

  useEffect(() => {
    fetchData();
  }, [startDate, endDate, userId]);

  const handleDelete = async (itemId, time) => {
    try {
      deleteEntry(itemId, time);
      fetchData();
    } catch (error) {
      console.error("Error deleting entry:", error);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const { milk, feed, ghee, moneyGiven, moneyReceived, Before } =
        await fetchBalance(startDate, endDate, userId);
      const sheetData = await fetchBalanceEntries(startDate, endDate, userId);
      setBalanceData(sheetData);
      console.log(sheetData);
      setPreviousBalance(Before.total);
      const fix = (role==="admin" && !userId)? -1:1;
      const total =
        Number(sheetData.morning?.total || 0) +
        Number(sheetData.evening?.total || 0) -
        Number(feed?.totalMoney || 0) -
        fix * Number(moneyReceived?.totalMoney || 0) +
        fix * Number(moneyGiven?.totalMoney || 0) -
        Number(ghee?.totalMoney || 0);

      setTotal(total);

      const grand =
        Number(Before?.total || 0) +
        Number(sheetData.morning?.total || 0) +
        Number(sheetData.evening?.total || 0) -
        Number(feed?.totalMoney || 0) -
        fix * Number(moneyReceived?.totalMoney || 0) +
        fix * Number(moneyGiven?.totalMoney || 0) -
        Number(ghee?.totalMoney || 0);

      setGrandTotal(grand.toFixed(2));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingScreen />;
  }
  

  const tableData = [
    {
      item: "Milk (Morning)",
      date: "",
      quantityDisplay: Number(balanceData.morning.weight || 0).toFixed(1) + " Kg",
      name: "",
      money: balanceData.morning.total || 0,
    },
    {
      item: "Milk (Evening)",
      date: "",
      quantityDisplay: Number(balanceData.evening.weight || 0).toFixed(1) + " Kg",
      name: "",
      money: balanceData.evening.total || 0,
    },
    ...balanceData.borrow.map((item) => {
      // Step 1: Swap the label ONLY for display if it's the logged-in user's perspective
      let displayItem = item.item;
      if (userId) {
        if (item.item.includes("Money Received")) {
          displayItem = "Money Given";
        } else if (item.item.includes("Money Given")) {
          displayItem = "Money Received";
        }
      }
    
      // Step 2: Apply sign logic separately (based on the ORIGINAL item type, not the display label)
      const isExpense =
        item.item.includes("Money Given") ||
        item.item.includes("Feed") ||
        item.item.includes("Ghee");
    
      return {
        item: displayItem,
        date: item.date,
        quantityDisplay:
          item.quantity && item.price
            ? `${item.quantity} pcs. × ${item.price} ₹`
            : "",
        name: item.name,
        money: isExpense
          ? -Math.abs(item.money || 0)
          : Math.abs(item.money || 0),
        id: item.id,
      };
    }),    
  ];

  return (
    <div className="md:mb-8 md:p-6 rounded-xl shadow-lg bg-white px-3 ">
      {/* Header */}
      <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-6 pb-3">
        Transaction Details
      </h3>

      {/* Transaction Items */}
      <div className="space-y-4">
        <TransactionItem
          data={tableData}
          admin={admin}
          onDelete={handleDelete}
          role={role}
        />
      </div>

      {/* Divider */}
      <div className="my-8">
        <hr className="border-t-2 border-gray-300" />
      </div>

      {/* Summary Section */}
      <div className="px-5 py-4 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl shadow-sm border border-gray-200">
        {/* Net Difference */}
        <div className="flex justify-between items-center mb-3 pb-2 border-b border-gray-200">
          <div className="flex items-center space-x-2">
            <div className="p-2 bg-blue-100 rounded-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-600"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <span className="text-gray-600 font-medium text-sm sm:text-base">
              Net Difference
            </span>
          </div>
          <span className="text-sm sm:text-lg font-semibold text-gray-800 bg-blue-50 px-3 py-1 rounded-full whitespace-nowrap">
            {Total.toFixed(1)} ₹
          </span>
        </div>

        {/* Previous Balance */}
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center space-x-2">
            <div className="p-2 bg-amber-100 rounded-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-amber-600"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm.707-10.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L9.414 11H13a1 1 0 100-2H9.414l1.293-1.293z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <span className="text-gray-600 font-medium text-sm sm:text-base">
              Previous Balance
            </span>
          </div>
          <span
            className={`text-sm sm:text-lg font-semibold px-3 py-1 rounded-full whitespace-nowrap ${
              previousBalance >= 0
                ? "bg-green-100 text-green-800"
                : "bg-red-100 text-red-800"
            }`}
          >
            {previousBalance >= 0
              ? `+${previousBalance.toFixed(2)}`
              : previousBalance.toFixed(2)}{" "}
            ₹
          </span>
        </div>

        {/* Final Total */}
        <div className="flex justify-between items-center mt-5 pt-4 border-t border-gray-300">
          <div className="flex items-center space-x-2">
            <div className="p-2 bg-indigo-100 rounded-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-indigo-600"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
                <path
                  fillRule="evenodd"
                  d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <span className="text-gray-700 font-bold text-sm sm:text-lg">
              Final Total
            </span>
          </div>
          <span
            className={`text-base sm:text-xl font-bold px-4 py-2 rounded-lg shadow-sm whitespace-nowrap ${
              parseFloat(grandTotal) >= 0
                ? "bg-gradient-to-r from-blue-50 to-indigo-50 text-blue-800 border border-blue-200"
                : "bg-gradient-to-r from-red-50 to-rose-50 text-red-800 border border-red-200"
            }`}
          >
            {grandTotal} ₹
          </span>
        </div>
      </div>
    </div>
  );
}

export default BalanceSheet;
